var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-layout',{attrs:{"direction":"column"}},[(_vm.hasLocalSchema)?_c('ui-auto-form',{attrs:{"modelValue":_vm.localSchema,"submit-handler":_vm.saveIntegration,"reset-handler":_vm.configId ? _vm.resetIntegration : undefined,"loading":_vm.loading},on:{"update:modelValue":function($event){_vm.localSchema = $event}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }